<template>
  <div class="download-blocker-popup">
    <div class="download-blocker-popup__inner">
      <NewsletterDownloadsContent v-if="!isComplete" />
      <NewsletterForm stacked @complete="onFormComplete" />

      <a
        id="downloadFileAnchor"
        :href="file"
        target="_blank"
        download
        @click="onFileDownload"
      >
        {{
          !isComplete
            ? downloadsSkipLabel
            : 'If your download does not start, click here'
        }}
      </a>
    </div>
    <div class="download-blocker-popup__close" @click="cancelPopup" />
  </div>
</template>

<script setup lang="ts">
const { downloadsSkipLabel } = useNewsletterContent()
const { setFormCookie } = useNewsletterPopupStore()

defineProps<{
  file: string
}>()

const isComplete = ref(false)

const emit = defineEmits(['download-file', 'cancel'])

function onFormComplete() {
  isComplete.value = true
  nextTick(() => emit('download-file'))
}

function onFileDownload() {
  if (isComplete.value) {
    setFormCookie(true)
  }
}

function cancelPopup() {
  emit('cancel')
}
</script>

<style lang="less" scoped>
.download-blocker-popup {
  .fixed();
  .animate-show();

  top: 0;
  left: 0;
  z-index: 10005;
  width: 100vw;
  height: 100vh;
  background-color: fade(@color-fill-text, 50%);
  backdrop-filter: blur(3px);
  padding: 0 @gutter;

  display: flex;
  align-items: center;
  justify-content: center;

  @media print {
    .hidden();
  }

  .download-blocker-popup__close {
    .absolute-fill();
    top: 0;
    left: 0;
    cursor: pointer;
  }

  .download-blocker-popup__inner {
    .relative();
    .round(18);
    z-index: 1;

    min-width: @320px;
    max-width: @480px;
    padding: @gutter;
    background: @color-fill-text;
    color: @color-text-reverse;

    @media @tablet {
      padding: @gutter-xl @gutter-xl @gutter;
    }

    > a {
      .font-size(15);
      .block();
      .text-center();
      appearance: none;
      border: none;
      background: none;
      color: inherit;
      padding: 0;
      margin: @gutter auto 0;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
